import AbstractDialog from '@maison/wrappers/AbstractDialog';

export default class Modal extends AbstractDialog {
  constructor(element, options = {}) {
    super('modal', element, options);
  }
}
